import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import CheckboxButton from 'shared-components/buttons/checkbox-button';
import Button from '../../elements-buttons/Button';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { Spinner } from 'shared-components/decorators/spinner';
import validateSyncChoices from './validation/validateSyncChoices';

const renderField = ({ placeholder, errorMessage, meta, input }) => {
  return (
    <div className="margin-lg-top margin-lg-bottom text-left">
      <input
        type="text"
        {...input}
        className="form-control"
        placeholder={placeholder}
      />
      {
        (meta.error && meta.touched) &&
        <div className="margin-md-top error text-danger text-small">
          {errorMessage}
        </div>
      }
    </div>
  );
};

class WhyCantSyncModal extends React.Component {
  constructor (props) {
    super(props);
    this.state = { analyticsCalled: false };
    this.handleChange = this.handleChange.bind(this);
    this.syncChoiceOptions = this.syncChoiceOptions.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidUpdate () {
    if (!this.state.analyticsCalled) {
      const { whichModal } = this.props;
      if (whichModal && whichModal !== 'WhyCantSyncModal') return;
      this.props.calendarSurveyAnalytics('why cant you sync');
      this.setState({ analyticsCalled: true });
    }
  }

  handleChange ({ input, option }, event) {
    const inputValue = input.value;
    const arr = [...inputValue];
    if (event.target.checked) {
      arr.push(option);
    } else {
      arr.splice(arr.indexOf(option), 1);
    }
    return input.onChange(arr);
  }

  syncChoiceOptions ({ input, options, meta }) {
    const { name } = input;
    const inputValue = input.value;
    const { error, submitFailed, touched } = meta;
    const showError = !!((error && submitFailed) || (error && touched));
    const optionsTextArray = [
      <FormattedMessage
        id="shared.cant_sync_options.no_access"
        defaultMessage="I can't access the other calendar right now"
      />,
      <FormattedMessage

        id="shared.cant_sync_options.not_compatible"
        defaultMessage="My calendar is not compatible with Peerspace"
      />,
      <FormattedMessage
        id="shared.cant_sync_options.dont_know_how"
        defaultMessage="I don't how to import my calendar"
      />,
      <FormattedMessage
        id="shared.cant_sync_options.no_time"
        defaultMessage="I don't have time right now"
      />,
      <FormattedMessage
        id="shared.cant_sync_options.dont_want_to"
        defaultMessage="I don't want to import or sync any calendars"
      />
    ];
    const syncChoices = options.map((option, idx) => {
      return (
        <CheckboxButton
          key={option}
          text={optionsTextArray[idx]}
          value={option}
          blockElement
          classNames="margin-lg-bottom"
          rounded
          checked={inputValue.includes(option)}
          name={`${name}[${option}]`}
          onChange={(e) => this.handleChange({ input, option }, e)}
        />
      );
    });
    return (
      <div className="flex column margin-lg-bottom">
        {syncChoices}
        <Field
          name="other_selected"
          component={({ input }) => {
            return (
              <CheckboxButton
                text="Other"
                checked={input.value}
                blockElement
                rounded
                onChange={(e) => {
                  input.onChange(e.target.checked);
                }}
              />
            );
          }}
        />
        {
          showError &&
          <div className="text-danger text-small">
            <FormattedMessage
              id="shared.select-an-option.error-text"
              defaultMessage="Please select at least one, or go back."
            />
          </div>
        }
      </div>
    );
  }

  onSubmit (values) {
    const { updateSyncReasons } = this.props;
    updateSyncReasons(values);
    this.props.toggleModal('ReminderModal');
  }

  render () {
    const { changeModal, showModal, handleSubmit, toggleModal, host_survey_form: hostSurveyForms, returnModal } = this.props;

    const syncOptions = ["I can't access the other calendar right now","My calendar is not compatible with Peerspace","I don't how to import my calendar","I don't have time right now","I don't want to import or sync any calendars"];
    const { other_selected } = hostSurveyForms;
    return (
      <BootstrapModal
        showModal={showModal}
        toggleModal={toggleModal}
        modalClass="host-survey-modal"
        goBack={() => toggleModal(returnModal)}
        header={
          <div>
            <h3>
              <FormattedMessage
                id="shared.why_cant_sync.header"
                defaultMessage="Why can't you sync your calendar?"
              />
            </h3>
            <p className="padding-md-top">
              <FormattedMessage
                id="shared.why_cant_sync.header_text"
                defaultMessage="Hosts with synced calendars tend to get more bookings."
              />
            </p>
          </div>
        }
        body={
          <form onSubmit={handleSubmit(this.onSubmit)}>
            {
              0 === syncOptions.length ?
                <div className="margin-xs-bottom">
                  <Spinner additionalStyle="gray large" />
                </div>
                :
                <Field
                  options={syncOptions}
                  name="cannot_sync_reasons"
                  component={this.syncChoiceOptions}
                />
            }
            {
              other_selected &&
              <Field
                name="other_reason"
                component={renderField}
                showErrorOnChange
                placeholder="Please write in your other reason (Required)"
                errorMessage='Please write in your other reason.'
              />
            }
            <Button
              category="primary"
              className="btn-block"
              isLoading={false}
            >
              <FormattedMessage
                id='inbox.host_survey_modal.peerspace_other_calendar_cta'
                defaultMessage='Next'
              />
            </Button>
          </form>
        }
        bodyClass="sync-modal-body"
      />
    );
  }
}

const config = {
  form: 'CALENDAR_CHOICES_FORM',
  validate: validateSyncChoices
};

WhyCantSyncModal.propTypes = {
  showModal: PropTypes.bool,
  updateSurveyState: PropTypes.func,
  toggleModal: PropTypes.func,
  changeModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  returnModal: PropTypes.string,
  calendarSurveyAnalytics: PropTypes.func
};

export default reduxForm(config)(WhyCantSyncModal);
